import React from 'react';
import styled from 'styled-components';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search…',
  className
}) => (
  <Input
    type="text"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    className={className}
  />
);

const Input = styled.input`
  flex: 1;
  min-width: 180px;
  padding: 7px 12px;
  border: 1px solid var(--line);
  border-radius: 7px;
  font-family: var(--font-sans);
  font-size: 13px;
  background: var(--paper);
  color: var(--ink);
  outline: none;

  &:focus {
    border-color: var(--ink-faint);
  }

  &::placeholder {
    color: var(--ink-faint);
  }
`;
